var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"offer-card-top",class:{
    'offer-card-top--with-exclusive-badge': _vm.isAlaoExclusiveOffer
  }},[(_vm.$slots.prepend)?_c('span',{staticClass:"offer-card-top__prepend"},[_vm._t("prepend")],2):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.$slots.append)?_c('span',{staticClass:"offer-card-top__append"},[_vm._t("append")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }